import { render } from "./SoundOn.vue?vue&type=template&id=a9882734&scoped=true"
import script from "./SoundOn.vue?vue&type=script&lang=js"
export * from "./SoundOn.vue?vue&type=script&lang=js"

import "./SoundOn.vue?vue&type=style&index=0&id=a9882734&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9882734"]])

export default __exports__